import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { updateEventName } from 'gqlQueries/promoRecommendation';
import { notification } from 'antd';

const errorMessage: string = 'Something went wrong!';

function useUpdateEventName(onComplete = () => {}) {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    //To fetch dim
    const [updateEventNameFunction, { loading: EventResponseLoading, error: EventResponseError }] = useMutation(
        updateEventName,
        {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        },
    );

    useEffect(() => {
        setLoading(EventResponseLoading);
    }, [EventResponseLoading]);

    const openNotification = (message: any) => {
        notification.open({
            message: message,
            className: 'custom-class',
            style: {
                width: 300,
                height: 70,
            },
        });
    };

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            onComplete();
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setLoading(false);
        setError(error);
        openNotification('Something went wrong!');
    }

    return {
        loading,
        error,
        updateEventNameFunction: (variables: any) => {
            updateEventNameFunction(variables);
        },
        onFetchComplete,
    };
}

export default useUpdateEventName;
